// -----------------------------
// swiper系
// -----------------------------

(function () {
  //swiper
  let sampleSlide = new Swiper(".js-case-slide", {
    navigation: {
      nextEl: ".case-btn-next",
      prevEl: ".case-btn-prev",
    },
    pagination: {                       //ページネーション（ドット）
        el: '.case-pagination',
    },
    autoplay: true,
    loop: true,
    speed: 600,
    slidesPerView: 1,
    spaceBetween: 60,
    breakpoints: {
      769: {
        spaceBetween: 30,
        slidesPerView: 1,
      },
    },
  });
})();
